import React from "react";
import { isResellerDomain } from "../../../CommonComponents/Utils";

export default class ProductDetailInformationWidget extends React.Component<{}> {
    render() {
        return(
          <div>-
            </div>
        );
    }
}